import { createApp } from 'vue'
import {createPinia} from 'pinia';
import App from './App.vue'
import router from './router'
// 路由守卫
import './router/router-guard';
import './assets/main.css';
// element-plus 样式
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
//
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css';

const app = createApp(App)

app.use(router)

app.use(ElementPlus)
app.use(createPinia())
app.mount('#app')
